import { GridPattern } from "./GridPattern";

const STATS = [
  { value: "10 anos", label: "de mercado" },
  { value: "+60.000", label: "clientes ativos" },
  { value: "100%", label: "de adimplência desde o início" },
  { value: "3ª maior", label: "do mundo no segmento" },
];

export const ParceirosV2TrustBar = () => {
  return (
    <section className="bg-white border-y border-zinc-200 relative overflow-hidden">
      <GridPattern />
      <div className="container-wide px-6 sm:px-6 md:px-12 py-6 sm:py-7 md:py-8 relative">
        <div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
            {STATS.map((stat) => (
              <div key={stat.label} className="text-center">
                <div
                  className="text-lg sm:text-xl md:text-2xl font-extrabold text-[#323F4F] leading-none"
                  style={{
                    fontFamily:
                      '"Plus Jakarta Sans", Inter, system-ui, sans-serif',
                    letterSpacing: "-0.03em",
                  }}
                >
                  {stat.value}
                </div>
                <div className="mt-1.5 text-[11px] sm:text-xs text-zinc-600 leading-snug max-w-[16ch] mx-auto">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>

          <p className="mt-5 text-center text-[10px] sm:text-[11px] text-zinc-500 max-w-3xl mx-auto leading-relaxed">
            Operação Allugator Serviços Digitais · Emissão via Allu Invest
            Securitizadora · Divulgação Dexcap (CVM 88)
          </p>
        </div>
      </div>
    </section>
  );
};
